<template>
  <div class="fu-chips" :class="`fu-chips--${layout}`" role="group" aria-label="View">
    <button
      v-for="v in views"
      :key="v.key"
      type="button"
      class="fu-chip"
      :class="{ 'fu-chip--on': v.key === value }"
      :aria-pressed="v.key === value ? 'true' : 'false'"
      :data-test="`fu-view-chip-${v.key}`"
      @click="$emit('input', v.key)"
    >
      {{ v.label }}<span class="fu-chip__count">{{ v.count }}</span>
    </button>
  </div>
</template>

<script>
/**
 * The view chips above the table — All / Due now / Upcoming / Not set / Stopped or done, each with
 * its count (src/utils/followups/filterSort.js VIEWS + countsByView). Presentational: v-model.
 */
export default {
  name: 'FollowupsViewChips',
  props: {
    views: { type: Array, default: () => [] },   // [{ key, label, count }]
    value: { type: String, default: 'all' },
    layout: { type: String, default: 'desktop' },
  },
};
</script>

<style lang="scss" scoped>
@import './mixins';

.fu-chips {
  display: flex;
  align-items: center;
  gap: $fu-space-2;
  flex-wrap: wrap;
  max-width: 100%;
}

// Phone: one line that scrolls sideways instead of wrapping into a block of chips.
.fu-chips--phone {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  padding-bottom: 2px;
  &::-webkit-scrollbar { display: none; }
}

.fu-chip {
  @include fu-chip(false);
}

.fu-chip--on {
  @include fu-chip(true);
}

.fu-chip__count {
  @include fu-tabular;
  opacity: 0.6;
}

.fu-chip--on .fu-chip__count {
  opacity: 0.75;
}
</style>
